import script from "./LanguageAccolade.vue?vue&type=script&setup=true&lang=js"
export * from "./LanguageAccolade.vue?vue&type=script&setup=true&lang=js"

import "./LanguageAccolade.vue?vue&type=style&index=0&id=022e069e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-022e069e"]])

export default __exports__